import { FundingPolicyType } from '@shared';

// Shared conditional definitions for Nationwide forms
export const oneAmericaSharedDefs = {
  conditionals: {
    policyOwner: {
      notClientOrJoint: {
        field: 'policyOwners',
        operator: 'notContains' as const,
        value: ['owner_client', 'owner_joint'],
      },
      isClientOnly: {
        field: 'policyOwners',
        operator: 'contains' as const,
        value: 'owner_client',
      },
      isJointOnly: {
        field: 'policyOwners',
        operator: 'contains' as const,
        value: 'owner_joint',
      },
    },
    fundingPolicy: {
      isJointCareMatters: {
        field: 'fundingPolicyType',
        operator: 'equals' as const,
        value: FundingPolicyType.jointCareMatters,
      },
    },
    insured: {
      isClientInsured: {
        field: 'clientInsured',
        operator: 'equals' as const,
        value: true,
      },
      isNotClientInsured: {
        field: 'clientInsured',
        operator: 'equals' as const,
        value: false,
      },
      isClientInsuredNo: {
        field: 'clientInsured',
        operator: 'equals' as const,
        value: 'no',
      },
    },
    policyOwnerSpecific: {
      notOwnerClient: {
        field: 'policyOwners',
        operator: 'notEquals' as const,
        value: 'owner_client',
      },
    },
  },
  requiredParameters: [
    {
      key: 'clientFullName',
      description: 'The full name of the client for personalizing form questions',
      type: 'string',
      required: true,
    },
    {
      key: 'clientPartnerFullName',
      description: 'The full name of the client partner for personalizing form sections',
      type: 'string',
      required: false,
    },
    {
      key: 'fundingPolicyType',
      description: 'The type of policy being applied for',
      type: 'number',
      required: true,
    },
  ] as FormParameter[],
};
